import { render } from "./DownloadCenter.vue?vue&type=template&id=47a5948e&scoped=true&bindings={}"
import script from "./DownloadCenter.vue?vue&type=script&lang=ts"
export * from "./DownloadCenter.vue?vue&type=script&lang=ts"

import "./DownloadCenter.vue?vue&type=style&index=0&id=47a5948e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47a5948e"

export default script